import React from 'react';
import {ReactComponent as Icon} from 'images/icon/trigger-tag.svg';

export default class extends React.PureComponent {
  render() {
    return <Icon className="icon tag" onClick={this.props.onClick} />;
  }
}
